import React from "react";
import styles from "./DonutChart.scss";
import cx from "../../utils/cx";
import { IFinancialCheckData } from "./FinancialCheckPage";
import Translate from "../../utils/Translate";


interface IDonutChartProps {
    className?: string;
    loanData: IFinancialCheckData['loanData'];
}

const DonutChart: React.FC<IDonutChartProps> = ({ loanData, className }) => {

    if (!loanData?.price) return null;

    const total = loanData?.price + loanData?.closingCosts;
    const closingCostsPercentage = loanData?.closingCosts / total * 100;
    const equityPercentage = loanData?.equity / total * 100;

    // test bug with strokeDashoffset="25"
    // const [equityPercentage, setEquityPercentage] = React.useState(0);
    // setTimeout(() => { setEquityPercentage(prev => prev + 1) }, 500);

    return <div className={cx(styles.finacialCheckDonutChart, className)}>
        <svg viewBox="0 0 42 42" className="donut">
            <circle className="donut-hole" cx="21" cy="21" r="15.9154943" fill="#fff"></circle>
            <circle className="donut-ring" cx="21" cy="21" r="15.9154943" fill="transparent" stroke="#8CD000" strokeWidth="3"></circle>
            <circle className="donut-segment" cx="21" cy="21" r="15.9154943" fill="transparent" stroke="#FF8F00" strokeWidth="3"
                strokeDashoffset="0" style={{ strokeDasharray: `${Math.min(100, Math.round(equityPercentage))} ${100 - Math.min(100, Math.round(equityPercentage))}` }}></circle>
        </svg>
        <svg viewBox="0 0 42 42" className="donut">
            <circle className="donut-hole" cx="21" cy="21" r="15.9154943" fill="#fff"></circle>
            <circle className="donut-ring" cx="21" cy="21" r="15.9154943" fill="transparent" stroke="#00ACD3" strokeWidth="6"></circle>
            <circle className="donut-segment" cx="21" cy="21" r="15.9154943" fill="transparent" stroke="#9B348E" strokeWidth="6"
                strokeDasharray={`${Math.min(100, Math.round(closingCostsPercentage))} ${100 - Math.min(100, Math.round(closingCostsPercentage))}`} strokeDashoffset="0"></circle>
        </svg>
        <div className={styles.summary}>
            Gesamtkosten:
            <span>{Translate.getNumber(total)} €</span>
        </div>
    </div>
};


export default DonutChart;